import axios, { getData } from 'lib/axios'

export const getOrder = async (row, page, order_type_id) => {
  const response = await axios.get(
    ` /orders/history?per_page=${row}&page=${page}&order-type-id=${order_type_id}`
  )
  return getData(response)
}
export const postOrder = async (data) => {
  const response = await axios.post(`orders`, data)
  return getData(response)
}
export const checkOrder = async (data) => {
  const response = await axios.post(`orders/check`, data)
  return getData(response)
}
export const postOrderPayment = async (payment_id, data) => {
  const response = await axios.post(`orders/${payment_id}/payments`, data)
  return getData(response)
}
export const getPayment = async (payment_id) => {
  const response = await axios.get(`/payments/${payment_id}`)
  return getData(response)
}
export const getOrderPayment = async (order_id) => {
  const response = await axios.get(`/orders/${order_id}/payments`)
  return getData(response)
}
export const postPayWithCredit = async (data) => {
  const response = await axios.post(`/payment-gateway/account`, data)
  return getData(response)
}
export const getCredit = async (account_id = 1) => {
  const response = await axios.get(`/accounts/${account_id}`)
  return getData(response)
}

// LINE SEPARARITNGI JASPDPOASDASODAIDASODIAPSIDIASDOPASD
export const payWithCredit = async (data) => {
  const response = await axios.post(`/recruitment/orders/pay-with-credits`, data)
  return getData(response)
}
export const buyCreditPackage = async (data) => {
  const response = await axios.post(`/recruitment/orders/purchase-credits`, data)
  return getData(response)
}

export const getOrderHistory = async (row, page) => {
  const response = await axios.get(`/recruitment/orders/history?total=${row}&page=${page}`)
  return getData(response)
}

export const getOneOrderHistory = async (adxOrder) => {
  const response = await axios.get(`/recruitment/orders/history/${adxOrder}/item-list`)
  return getData(response)
}
// export const getReceipt = async (order_id) => {
//   const response = await axios
//       .get(`/recruitment/orders/${order_id}/invoice`,{
//         responseType: 'blob',
//       })
//   return getData(response)
// }
export const getReceipt = async (order_id) => {
  const response = await axios.get(`/recruitment/orders/${order_id}/invoice`, {
    responseType: 'blob',
  })

  const url = window.URL.createObjectURL(new Blob([response.data]))
  return url
}
